import React, { Component } from "react";
import moment from 'moment';
import _ from 'lodash';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck, faUsers, faTag } from "@fortawesome/free-solid-svg-icons";
import "./HistoryCard.scss";
import { Link } from "react-router-dom";

const TYPES = {
  ITEM: "ITEM",
  SITE: "SITE",
  COLLECTION: "COLLECTION",
}

const ACTIONS = {
  MODIFY: { 
    NAME: "MODIFY",
    DISPLAY: "Updated",
  },
  INSERT: { 
    NAME: "INSERT",
    DISPLAY: "Added",
  },
  REMOVE: {
    NAME: "REMOVE",
    DISPLAY: "Removed",
  }
};


class HistoryCard extends Component {

  handleGotoDetail = (e) => {
    const { data, history } = this.props;
    e.preventDefault();
    e.stopPropagation();
    this.props.setItem(data.id);
    history.push(`/item/detail/${data.id}`, {
      id: data.id,
      data
    });
  }
  
  titleCaseWord = str => {
    const newStr = str.toLowerCase();
    const firstChar = newStr[0].toUpperCase();
    return firstChar + newStr.slice(1, newStr.length);
  }
  
  /**
   * Build a title like:
   * 'Updated Item'
   * 'Added Item'
   * 'Removed Item'
   */
  buildActionTitle = (event) => {
    const {action, type} = event;
    const actionTitle = `${ACTIONS[action].DISPLAY} ${this.titleCaseWord(type)}`;
    return actionTitle;
  }
  
  buildActionLink = (event) => {
    if (event.type === TYPES.ITEM && event.id) {
      const detailUrl = `/item/detail/${event.id}`;
      return (<Link to={detailUrl} className="item-link">VIEW ITEM</Link>);
    } else if (_.get(event, 'urls.target')) {
      const externalUrl = _.get(event, 'urls.target');
      return (<a className="item-link" href={externalUrl} target="_blank" rel="noopener noreferrer">VIEW ITEM</a>);
    }
    return "";
  }

  render() {
    
    return (
      <div className="history-card-container">
          {
            (this.props.activities || []).sort((a, b) => {
              if (a.timestampNano < b.timestampNano) {
                return 1;
              } else if (a.timestampNano === b.timestampNano) {
                return 0;
              } else {
                return -1;
              }
            }).map((evt, idx) => {
              const timestamp = Math.floor(evt.timestampNano/1000000);
              const time = moment(timestamp).fromNow()

              return (
                <div key={idx} className="time-line-event">
                  <div className="d-flex event-header">
                  {evt.icon ? <img src={evt.icon} alt="event symbol" /> : <div className="icon-placeholder" />}
                    <span className="event-title">{this.buildActionTitle(evt)}</span>
                  </div>
                  <p className="description">{evt.title}</p>
                  {this.buildActionLink(evt)}
                  <p className="text-right time">{time}</p>
                </div>
            )
            })
          }
      </div>
    );
  }
}

export default HistoryCard;
